<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <div class="component-header-title">
      <h2>Edit Pyramidal Shareholder</h2>
      @if (pyramidalShareholderData?.name) {
        <p class="component-header-subtitle">{{ pyramidalShareholderData?.name }}</p>
      }
    </div>

    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onAddPyramidItem()" *ngIf="isPyramidTabActive">
        <mat-icon>add</mat-icon>
        Add new pyramid item
      </button>
    </div>
  </div>
  <app-pyramidal-shareholder-form
    #pyramidalShareholderForm
    [form]="form"
    [isEditMode]="true"
    [initialTabIndex]="initialTabIndex"
    [pyramidsByYear]="pyramidsByYear"
    submitButtonText="Update Pyramidal Shareholder"
    (submit)="onSubmit()"
    (cancel)="onCancel()"
    (editPyramidItem)="onEditPyramidItem($event)"
    (deletePyramidItem)="onDeletePyramidItem($event)">
  </app-pyramidal-shareholder-form>
</div>
